import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadBudgets,
  loadBudgetsFailure,
  loadBudgetsSuccess,
  submitProject, submitProjectFailure,
  submitProjectSuccess
} from '../actions/civic-budget.actions';
import { concatMap, map, of, switchMap, withLatestFrom } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CivicBudgetCommonService } from '../../services/civic-budget.common.service';
import { Store } from '@ngrx/store';
import { selectBudgets } from '../selectors/civic-budget.selectors';
import { CivicBudgetProjectService } from '../../openapi';

@Injectable()
export class CivicBudgetEffects {
  constructor(
    private actions$: Actions,
    private store$: Store,
    private civicBudgetCommonService: CivicBudgetCommonService,
    private civicBudgetProjectService: CivicBudgetProjectService
  ) {
  }

  loadBudgets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBudgets),
      withLatestFrom(this.store$.select(selectBudgets)),
      concatMap(([action, budgets]) =>
        ((budgets.length && !action?.force) ? of(budgets) : this.civicBudgetCommonService.loadBudgets()).pipe(
          map(budgets => loadBudgetsSuccess({ budgets })),
          catchError(() => of(loadBudgetsFailure()))
        )
      )
    )
  );

  submitProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(submitProject),
      switchMap((action) =>
        this.civicBudgetProjectService.postCivicBudgetProjectCivicBudgetProjectCollection({
          civicBudgetProject: action.payload
        }).pipe(
          map(project => {
            action.successFnc();
            return submitProjectSuccess({ project });
          }),
          catchError((e) => {
            action.failureFnc(e);
            return of(submitProjectFailure());
          })
        )
      )
    )
  );
}
